export default __webpack_public_path__ + "static/media/logo.9b00a9ae.svg";